import { render } from "./TrickRecommendationPublicCard.vue?vue&type=template&id=170fdeba&scoped=true"
import script from "./TrickRecommendationPublicCard.vue?vue&type=script&lang=js"
export * from "./TrickRecommendationPublicCard.vue?vue&type=script&lang=js"

import "./TrickRecommendationPublicCard.vue?vue&type=style&index=0&id=170fdeba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-170fdeba"]])

export default __exports__